import { Divider, Grid, makeStyles } from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles({
  divider: {
    backgroundColor: 'rgba(0, 0, 0, 0.50)',
    marginBottom: 16,
  },
  title: {
    fontSize: 19,
    fontWeight: 500,
    marginBottom: 8,
  },
});

const FormTitle = ({ title }) => {
  const styles = useStyles();
  return (
    <>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <p className={styles.title}>{title}</p>
      </Grid>
      <Divider className={styles.divider} />
    </>
  );
};

export default FormTitle;
